import { searchLocationWithTransaction } from "apis";
import { FilterBar, FilterDateRange, FilterMultiSelect, FilterTimeRange } from "components/commons";
import { useApi, useMount } from "hooks";
import {
  locationWithTransactionFilterResponse,
  locationWithTransactionFilterRequest,
} from "mappers";
import React, { useCallback, useMemo } from "react";
import { mapObject, mapObjectsToSelect } from "services";
import lang from "translations";

const FreeCreditsReportFilter = ({
  filterState,
  requestState,
  modifyFilter,
  clearFilter,
  onClear,
  onApply,
}) => {
  const {
    request: searchLocationRequest,
    loading: loadingLocation,
    mappedData: locations,
  } = useApi({
    api: searchLocationWithTransaction,
    isArray: true,
    mapper: locationWithTransactionFilterResponse,
  });

  useMount(() => {
    fetchLocations(requestState);
  });

  const fetchLocations = useCallback(
    (requestState) => {
      searchLocationRequest(mapObject({ ...requestState }, locationWithTransactionFilterRequest));
    },
    [searchLocationRequest]
  );

  const applyFilterCb = useCallback(
    async (searchKey) => {
      await onApply(searchKey);
    },
    [onApply]
  );

  const clearFilterCb = useCallback(() => {
    const { filterState, requestState } = clearFilter();
    onClear(filterState, requestState);
    fetchLocations(requestState);
  }, [clearFilter, onClear, fetchLocations]);

  const changeDateRangeCb = useCallback(
    (value) => {
      const { requestState } = modifyFilter("dateRange", { value });
      fetchLocations(requestState);
    },
    [fetchLocations, modifyFilter]
  );

  const locationOptions = useMemo(() => {
    return mapObjectsToSelect(locations, { textKey: "name" });
  }, [locations]);

  return (
    <FilterBar
      className="my-lg"
      filterState={filterState}
      searchBox={false}
      onClear={clearFilterCb}
      onApply={applyFilterCb}
    >
      <FilterDateRange
        id="dateRange"
        label={lang.dateRange}
        maxDays={90}
        value={filterState.dateRange}
        onChange={changeDateRangeCb}
      />
      <FilterTimeRange
        id="timeRange"
        label={lang.timeRange}
        value={filterState.dateRange}
        onChange={(value) => modifyFilter("dateRange", { value })}
      />
      <FilterMultiSelect
        id="locations"
        label={lang.outlet}
        allLabel={lang.allLocations}
        emptyLabel={lang.noLocationAvailable}
        disableWhenEmpty={false}
        loading={loadingLocation}
        options={locationOptions}
        value={filterState.locations}
        onChange={(value) => modifyFilter("locations", { value })}
      />
    </FilterBar>
  );
};

export default FreeCreditsReportFilter;
